import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.DocumentQueueList })));

export default { list };
